import React from 'react';
import { useTranslation } from 'react-i18next';
import * as S from './SearchBaseResults.styles';
import { SkeletonLoader } from '@/components/SkeletonLoader/SkeletonLoader';
import { Breadcrumbs } from '@/components/Breadcrumbs/Breadcrumbs';
import { setSuffix } from '@/utils/helpers';
import { Typography } from '@/components/UI/Typography/Typography.styles';
import { usePropertyOptionsTitle } from '@/hooks/usePropertyOptionsTitle';
import { useAdsCount } from '@/hooks/useAdsCount';
import { useCurrentCategory } from '@/hooks/useCurrentCategory/useCurrentCategory';

export const SearchBaseResults = () => {
  const { i18n, t } = useTranslation();
  const { currentCategory } = useCurrentCategory();
  const { adsCount } = useAdsCount(currentCategory);
  const title = usePropertyOptionsTitle();
  const hasCount = adsCount !== undefined && adsCount !== null;

  return (
    <S.Box>
      <Breadcrumbs hasHorizontalPadding />
      <S.InnerBox>
        {title.length ? (
          <Typography.Header as="h1" $variant="3">
            {title}
          </Typography.Header>
        ) : (
          <SkeletonLoader width="160px" height="19.19px" />
        )}

        {hasCount ? (
          <S.Amount $variant="1">
            {t(setSuffix(i18n, adsCount.toString(), 'common.n_ads'), {
              n: adsCount,
            })}
          </S.Amount>
        ) : (
          <S.AmountSkeleton>
            <SkeletonLoader width="115px" height="18px" />
          </S.AmountSkeleton>
        )}
      </S.InnerBox>
    </S.Box>
  );
};
